import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { registerUser } from "../../redux/reducer/authReducer";
import CustomTitleWihBox from "../sharedComponents/customTitleWithBox";
import CustomInput from "./CustomInput";
import CustomPasswordInput from "../accountUser/customPasswordInput";
import {
  EnvelopeIcon,
  LockOpenIcon,
  UserIcon,
  PhoneIcon,
} from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import PhoneCodeDropdown from "../sharedComponents/PhoneCodeDropdown";
import CountryDropdown from "../sharedComponents/CountryDropdown";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";
import GoogleIcon from "../sharedComponents/GoogleIcon";
export default function RegistrationForm() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [country, setCountry] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [countryCodeDefualt, setCountryCodeDefualt] = useState("");
  const [errors, setErrors] = useState({});
  const navigateWithLang = useLanguageNavigate();

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const validateForm = () => {
    const newErrors = {};

    if (!firstName || firstName.length < 3) {
      newErrors.firstName = t("FirstNameMustBeAtLeast3Chars");
    }

    if (!lastName || lastName.length < 3) {
      newErrors.lastName = t("LastNameMustBeAtLeast3Chars");
    }

    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = t("EnterValidEmail");
    }

    if (!/^\d+$/.test(phone)) {
      newErrors.phone = t("PhoneNumbersOnly");
    } else if (phone.length < 8) {
      newErrors.phone = t("PhoneMinLength");
    }

    if (!password || password.length < 6) {
      newErrors.password = t("PasswordMinLength");
    }

    if (password !== confirmPassword) {
      newErrors.confirmPassword = t("PasswordsDoNotMatch");
    }

    if (!country) {
      newErrors.country = t("PleaseSelectCountry");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem("email", email);

    if (!validateForm()) return;

    const finalCountryCode = countryCode || countryCodeDefualt;

    const userData = {
      firstName,
      lastName,
      email,
      phone,
      countryCode: finalCountryCode,
      password,
      country,
    };

    dispatch(registerUser(userData))
      .unwrap()
      .then(() => {
        handleClick();
      })
      .catch((error) => {
        console.error(error);
        if (error?.message === "This email is already taken") {
          alert(t("EmailAlreadyTaken"));
          return;
        }
        alert(error?.message || t("RegistrationFailed"));
      });
  };

  const handleClick = () => {
    navigateWithLang("/otp");
  };

  const direction = useLanguageDirection();

  return (
    <div
      className="block p-8 mx-auto text-right bg-white rounded-lg shadow-lg md:w-2/3 max-w-[700px]"
      dir={direction}
    >
      <CustomTitleWihBox title={t("RegisterNewAccount")} />
      <form onSubmit={handleSubmit}>
        <div className="gap-4 lg:flex">
          {/* First Name */}
          <div className="mb-3 lg:w-1/2 md:mb-5">
            <CustomInput
              id="firstName"
              placeholder={t("FirstName")}
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              icon={<UserIcon />}
              required={true}
            />
            {errors.firstName && (
              <p className="mt-1 text-xs text-red-400 ps-3">
                {errors.firstName}
              </p>
            )}
          </div>

          {/* Last Name */}
          <div className="mb-3 lg:w-1/2 md:mb-5">
            <CustomInput
              id="lastName"
              placeholder={t("LastName")}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              icon={<UserIcon />}
              required={true}
            />
            {errors.lastName && (
              <p className="mt-1 text-xs text-red-400 ps-3">
                {errors.lastName}
              </p>
            )}
          </div>
        </div>

        {/* Email */}
        <div className="mb-3 md:mb-5">
          <CustomInput
            id="email"
            type="email"
            placeholder={t("email")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            icon={<EnvelopeIcon />}
            required={true}
          />
          {errors.email && (
            <p className="mt-1 text-xs text-red-400 ps-3">{errors.email}</p>
          )}
        </div>

        <div className="mb-3 md:mb-5 ">
          <CountryDropdown
            onSelect={(item) => {
              setCountry(item.name);
              setCountryCodeDefualt(item.phoneCode);
            }}
            required={true}
          />
          {errors.country && (
            <p className="mt-1 text-xs text-red-400 ps-3">{errors.country}</p>
          )}
        </div>

        <div
          className="flex flex-row-reverse items-center gap-3 md:gap-5 lg:flex-row-reverse row"
          dir="ltr"
        >
          {/* Phone */}
          <div className="w-4/6 lg:w-4/5">
            <CustomInput
              id="phone"
              type="tel"
              placeholder={t("PhoneNumber")}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              icon={<PhoneIcon />}
              required={true}
            />
          </div>
          {/* Phone Code & Selected Country ISO */}
          <div className="w-2/6 lg:w-1/5">
            <div className="">
              {/* Arabic Label */}

              <PhoneCodeDropdown
                onSelect={(item) => setCountryCode(item)}
                countryCodeDefualt={countryCodeDefualt}
                // value={countryCode}
              />
            </div>
          </div>
        </div>

        {errors.phone && (
          <p className="mt-1 text-xs text-red-400 ps-3">{errors.phone}</p>
        )}

        {/* Password & Confirm Password */}
        <div
          className="flex flex-col gap-3 my-3 md:my-5 lg:flex-row"
          dir={direction}
        >
          <div className="lg:w-1/2 ">
            <CustomPasswordInput
              id="password"
              type="password"
              // label={t("Password")}
              placeholder={t("Enteryourpassword")}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              icon={<LockOpenIcon />} // Optional: Add an icon prop if supported
            />
            {errors.password && (
              <p className="mt-1 text-xs text-red-400 ps-3">
                {errors.password}
              </p>
            )}
          </div>
          <div className="lg:w-1/2 ">
            <CustomPasswordInput
              id="confirm-password"
              type="password"
              // label={t("Password")}
              placeholder={t("confirmyourpassword")}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              icon={<LockOpenIcon />} // Optional: Add an icon prop if supported
            />
            {errors.confirmPassword && (
              <p className="mt-1 text-xs text-red-400 ps-3">
                {errors.confirmPassword}
              </p>
            )}
          </div>
        </div>

        {/* Submit Button */}
        <div className="flex flex-col justify-center gap-4 md:mb-6">
          <button
            type="submit"
            className="block w-full px-6 py-2 font-medium text-black transition duration-300 ease-in-out rounded-lg shadow-lg lg:text-lg lg:py-3 bg-custom-yellow hover:bg-primary-600 focus:outline-none"
          >
            {t("Register")}
          </button>
          <button
            type="button"
            className="flex items-center justify-center w-full gap-2 px-4 py-3 font-medium text-black duration-300 border rounded-lg border-custom-primary text-custom-primary hover:bg-custom-yellow lg:text-lg"
            onClick={() =>
              (window.location.href = "https://api.markaship.com/api/google")
            }
          >
            <GoogleIcon />
            <span className="flex-grow text-center">
              {t("googleSignInText")}
            </span>
            <span className="w-5"></span>
          </button>
        </div>

        {/* Navigation to Login */}
        <p className="mt-4 text-sm text-center text-gray-600">
          {t("AlreadyHaveAccount")}{" "}
          <div
            onClick={() => navigateWithLang("/login")}
            className="text-blue-600 cursor-pointer hover:underline"
          >
            {t("LoginHere")}
          </div>
        </p>
      </form>
    </div>
  );
}
